import { Assessment, Store } from '@mui/icons-material'

import { SidebarItemsType } from '@/types/sidebar'

const navItems = (): {
  title: string
  pages: SidebarItemsType[]
}[] => {
  return [
    {
      title: '',
      pages: [
        {
          href: '/reporting/user?sortBy=compliance&sort=ASCENDING',
          icon: Assessment,
          title: 'User Reporting',
          id: 'user-nav',
        },
        // {
        //   href: '/reporting/geographic',
        //   icon: Public,
        //   title: 'Geographic',
        //   id: 'geographic-nav',
        // },
        {
          href: '/reporting/plan?sortBy=priority&sort=ASCENDING',
          icon: Store,
          title: 'Plan',
          id: 'plan-nav',
        },
      ],
    },
  ]
}

export default navItems
